import { render, staticRenderFns } from "./deftersilmeyetkisi.vue?vue&type=template&id=38f95655&"
import script from "./deftersilmeyetkisi.vue?vue&type=script&lang=js&"
export * from "./deftersilmeyetkisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports